<template>
    <div class="sales-card-exclusive" v-if="filterCMSparams != null">
        <div class="sales-card-section-title"><h2>{{ salesCardArr.project_page_in.exclusive_title  }}</h2></div>
        <div class="ex-cards">
            <div class="card-item" v-for="item in salesCardArr.project_page_in.exclusive_cards">
                <router-link :to="{ name: 'flats-card' , params:{'id' : item.id_flat}}">
                    <div class="card-title"><h4>{{ item.title }}</h4></div>
                    <div class="card-img"><img :src="item.plan" alt=""></div>
                    <div class="card-info">
                        <div class="info-item">
                            <h6>{{ filterCMSparams.words_translation.size_def }}</h6>
                            <strong><span v-if="globalLang != 'kz/'">от</span> {{ item.size }} <span>м²</span></strong>
                        </div>
                        <div class="info-item">
                            <h6>{{ filterCMSparams.words_translation.price_def }}</h6>
                            <strong><span v-if="globalLang != 'kz/'">от</span> {{ item.price }} <span>млн. тг.</span></strong>
                        </div>
                    </div>
                    <div class="btn-more btn-wow-effect-hover">
                        <span>{{filterCMSparams.words_translation.flat_choose}}</span>
                        <svgIcon name="arrow-right" class="icon-right-arrow"/>
                    </div>
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import svgIcon from '@/components/partials/SvgIcon.vue'
    export default {
        name: 'sales-card-exclusive',
        props: ['salesCardArr'],
        components: {
            svgIcon,
        },
        data () {
            return {
                dataArr: null,
                globalLang: window.GlobalLang, 
            }
        },
        computed: mapGetters({
            filterCMSparams: 'loadFilterCMSparams',
            isMobileChecker: 'loadIsMobileChecker',
        }),
        methods: {
        },
        beforeCreate() {
        },
        created () {
        },
        mounted() {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/sales-card/sales-card-exclusive.scss';
    @import '@/styles/components/sales-card/respond/sales-card-exclusive-respond.scss';
</style>